import { useNavigate, useLocation } from 'react-router-dom';
import ProgressPathScreen from '../components/ProgressPathScreen';

const ProgressPath = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const currentLevel = location.state?.currentLevel || 1;
  const completedLevels = location.state?.completedLevels || [];
  const previousLevelResult = location.state?.previousLevelResult || null;
  const showConfetti = location.state?.showConfetti || false;
  
  // Get accumulated data to pass through
  const levelScores = location.state?.levelScores || {};
  const wrongQuestions = location.state?.wrongQuestions || [];
  const allAnsweredQuestions = location.state?.allAnsweredQuestions || [];

  const handleAnimationComplete = () => {
    navigate('/quiz', { 
      state: { 
        currentLevel, 
        completedLevels,
        fromProgress: true,
        // Pass accumulated data back to Quiz
        levelScores,
        wrongQuestions,
        allAnsweredQuestions
      } 
    });
  };

  return (
    <ProgressPathScreen
      currentLevel={currentLevel}
      completedLevels={completedLevels}
      previousLevelResult={previousLevelResult}
      showConfetti={showConfetti}
      onAnimationComplete={handleAnimationComplete}
    />
  );
};

export default ProgressPath;
